<template>
  <div>
    <p v-html="requestError.responseText" />
    <v-layout justify-center>
      <v-btn
        style="margin-left: -28px"
        color="sz_transparent_red"
        @click="copy()"
      >
        {{ $t('buttons.copy') }}
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
export default {
    name: 'Error400Sheets',
    computed: {
        requestError () {
            return this.$store.getters.getErrors;
        }
    },
    methods: {
        copy () {
            const copyText = document.querySelector('.sheet-error-message');
            const selection = document.getSelection();
            const range = document.createRange();
            range.selectNodeContents(copyText);
            selection.removeAllRanges();
            selection.addRange(range);
            document.execCommand('copy');
        }
    }
};
</script>

<style scoped></style>
